import { cva, type VariantProps } from "class-variance-authority";

export const videoClampVariants = cva("", {
  variants: {
    aspect: {
      "16:9": "md:content-container w-full",
      "9:16":
        "md:h-full md:max-h-[960px] md:aspect-[9/16] md:w-auto md:max-w-[540px]",
      "1:1":
        "md:h-full md:max-h-[960px] md:aspect-square md:w-auto md:max-w-[min(960px,100%)]",
      default:
        "md:h-full md:max-h-[960px] md:aspect-[9/16] md:w-auto md:max-w-[540px]",
    },
  },
  defaultVariants: {
    aspect: "default",
  },
});

export type VideoClampVariants = VariantProps<typeof videoClampVariants>;
